import { render, staticRenderFns } from "./repair_detail.vue?vue&type=template&id=d2938588&scoped=true"
import script from "./repair_detail.vue?vue&type=script&lang=js"
export * from "./repair_detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2938588",
  null
  
)

export default component.exports